import { axios_openSearch } from "../../../../api/setup.intersepter";

export const OpenSearchForTransaction = (body: any) => {
  return axios_openSearch({
    method: "POST",
    url: `/elastic_search/nurtureSearch`,
    data: body,
  });
};
